let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5vlNt")).then(() => parcelRequire('2yUWd'));